<template>
  <footer class="footer">
    <div class="footer-wrapper grid">
      <div class="footer-inner">
        <nav v-if="footer?.items" class="nav">
          <Logo class="logo" />
          <ul class="links-list">
            <li
              v-for="item in footer.items"
              :key="item.id"
              class="links-list-item"
            >
              <component
                :is="item.link ? BaseLink : 'span'"
                v-if="item.label"
                :link="item.link"
                class="link t-p-m-160"
              >
                <ChevronIcon class="icon" />
                {{ item.label }}
              </component>
            </li>
          </ul>
        </nav>
        <NavigationFooterTextSection
          v-if="footer?.contact_text"
          :content="footer.contact_text"
          class="info"
        />
        <div v-if="footer?.footer_newsletter_enabled" class="newsletter">
          <p class="title t-h5" v-text="t('footer.newsletter')" />
          <Newsletter />
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import ChevronIcon from '@/assets/icons/bullet-chevron.svg?component'
import { useFooterSettings } from '~/state/footerSettings'

const BaseLink = resolveComponent('BaseLink')
const { t } = useI18n()

const footer = await useFooterSettings()
</script>

<style lang="scss" scoped>
.footer {
  margin-inline: rem(18px);
  margin-bottom: rem(20px);
  background-color: $global-white;
  @include media-up(md) {
    margin-inline: rem(20px);
  }
}

.footer-wrapper {
  @include media-up(md) {
    margin-inline: rem(-20px);
  }
}

.footer-inner {
  --grid-columns: 1;
  @include column(xs, 12);
  display: grid;
  grid-template-columns: repeat(var(--grid-columns), 1fr);
  row-gap: rem(42px);
  column-gap: rem(80px);
  padding-block: rem(55px) rem(94px);

  @include media-up(md) {
    --grid-columns: 2;
  }
  @include media-up(s-lg) {
    --grid-columns: 3;
  }
}

.nav {
  @include media-up(md) {
    grid-column: 1 / 3;
  }

  @include media-up(s-lg) {
    grid-column: 1 / 2;
  }
}

.info {
  @include media-up(md) {
    grid-column: 1 / 2;
  }

  @include media-up(s-lg) {
    grid-column: 2 / 3;
  }
}

.newsletter {
  @include media-up(md) {
    grid-column: 2 / 3;
  }

  @include media-up(s-lg) {
    grid-column: 3 / 4;
  }
}

.logo {
  width: rem(141px);
  height: rem(55px);
  margin-bottom: rem(36px);

  :deep(img) {
    max-width: 100%;
    max-height: 100%;
  }
}

.link {
  display: inline-flex;
  align-items: center;
}

.icon {
  --icon-color: #{$layout-text-02};
  @include size(rem(18px));
  margin-right: rem(8px);
}

:deep(.title) {
  margin-bottom: rem(48px);
}
</style>
